// ========== 粒子生成系统（性能优化版）==========
import { safeStorage } from '../utils/storage.js';
import { devicePerformance, performanceMultiplier } from '../utils/performance.js';

const particleMultiplier = performanceMultiplier;

// 粒子类型配置（优化后）
// 高端设备：130个粒子，低端设备：65个粒子
const PARTICLE_TYPES = [
    { cls: 'p-small',  count: Math.floor(80 * particleMultiplier),  baseDur: 168, durVar: 0.20, maxDelay: 60  },
    { cls: 'p-medium', count: Math.floor(30 * particleMultiplier),  baseDur: 240, durVar: 0.20, maxDelay: 90  },
    { cls: 'p-large',  count: Math.floor(12 * particleMultiplier),  baseDur: 312, durVar: 0.20, maxDelay: 120 },
    { cls: 'p-xl',     count: Math.floor(8 * particleMultiplier),   baseDur: 384, durVar: 0.20, maxDelay: 150 }
];

console.log('🎨 粒子总数:', PARTICLE_TYPES.reduce((sum, t) => sum + t.count, 0));

const STORAGE_VERSION = 'v4';
const CLEANUP_FLAG = 'birchcloud_cleanup_done_v4';
const START_KEY = 'birchcloud_particle_start_' + STORAGE_VERSION;
const CACHE_KEY = 'birchcloud_particle_data_' + STORAGE_VERSION;

// 清理旧版本缓存数据（只执行一次）
function cleanupOldVersions() {
    if (safeStorage.get('local', CLEANUP_FLAG)) return;
    
    console.log('🧹 清理旧版本缓存数据...');
    const oldVersions = ['v1', 'v2', 'v3'];
    oldVersions.forEach(version => {
        safeStorage.remove('local', 'birchcloud_particle_start_' + version);
        safeStorage.remove('session', 'birchcloud_particle_data_' + version);
    });
    
    safeStorage.set('local', CLEANUP_FLAG, 'true');
    console.log('✅ 旧版本缓存清理完成');
}

// 验证缓存数据
function validateCachedData(data, expectedCount) {
    if (!Array.isArray(data) || data.length !== expectedCount) {
        return false;
    }
    return data.every(p => 
        typeof p.l === 'string' && 
        typeof p.d === 'string' && 
        typeof p.r === 'string'
    );
}

// 获取或初始化时间参考点
function getStartTime() {
    let startTime = safeStorage.get('local', START_KEY);
    let startTimeValid = false;
    
    if (startTime) {
        const parsed = parseFloat(startTime);
        const now = Date.now();
        const thirtyDays = 30 * 86400 * 1000;
        
        if (!isNaN(parsed) && parsed > 0 && parsed <= now && (now - parsed) < thirtyDays) {
            startTimeValid = true;
        }
    }
    
    if (!startTimeValid) {
        startTime = Date.now();
        safeStorage.set('local', START_KEY, startTime);
        safeStorage.remove('session', CACHE_KEY);
    }
    
    return parseFloat(startTime);
}

// 生成粒子
export function generateParticles() {
    const section = document.getElementById('textureSection');
    if (!section) return;
    
    // 清理旧版本缓存（只执行一次）
    cleanupOldVersions();
    
    const startTime = getStartTime();
    const elapsed = (Date.now() - startTime) / 1000;

    // 尝试从缓存恢复
    let cachedData = null;
    const raw = safeStorage.get('session', CACHE_KEY);
    if (raw) {
        try {
            const parsed = JSON.parse(raw);
            const expectedCount = PARTICLE_TYPES.reduce((sum, t) => sum + t.count, 0);
            if (validateCachedData(parsed, expectedCount)) {
                cachedData = parsed;
            }
        } catch(e) {}
    }

    const fragment = document.createDocumentFragment();
    let total = 0;
    const particleData = [];

    PARTICLE_TYPES.forEach(type => {
        for (let i = 0; i < type.count; i++) {
            const div = document.createElement('div');
            div.className = 'particle ' + type.cls;

            let left, duration, delay;
            if (cachedData && total < cachedData.length) {
                const c = cachedData[total];
                left = c.l;
                duration = c.d;
                delay = c.r;
            } else {
                left = (Math.random() * 98).toFixed(1);
                const durVar = 1 + (Math.random() - 0.5) * 2 * type.durVar;
                duration = (type.baseDur * durVar).toFixed(1);
                delay = (Math.random() * type.maxDelay).toFixed(1);
            }

            const totalDuration = parseFloat(duration);
            const originalDelay = parseFloat(delay);
            const effectiveDelay = -((elapsed + originalDelay) % totalDuration);

            div.style.cssText =
                'left:' + left + '%;' +
                'animation-duration:' + duration + 's;' +
                'animation-delay:' + effectiveDelay + 's;';

            fragment.appendChild(div);
            particleData.push({ l: left, d: duration, r: delay });
            total++;
        }
    });

    safeStorage.set('session', CACHE_KEY, particleData);

    const content = section.querySelector('.texture-content');
    section.insertBefore(fragment, content);
}
